import { IonSpinner } from '@ionic/react';
import { ApexOptions } from 'apexcharts';
import * as React from 'react';

import '@/pages/ReportV2/components/Graphs/graphCard.css';

import { useEffect } from 'react';
// eslint-disable-next-line import/default
import Chart from 'react-apexcharts';

import styles from '@/pages/ReportV2/components/Graphs/ApexCharts.module.css';

import { KinematicYAxis, kinematicGraphAnnotations } from '@/models/reportV2.model';

type KinematicsGraphProps = {
  data: any;
  title: string;
  subtitle: string;
  graphAnnotations: kinematicGraphAnnotations;
  strokeWidth: number;
  forPdf?: boolean;
  yAxis: KinematicYAxis;
};

// eslint-disable-next-line react/display-name
export const KinematicsGraph = React.forwardRef(
  (
    { data, title, subtitle, graphAnnotations, strokeWidth, forPdf = false, yAxis }: KinematicsGraphProps,
    ref: React.ForwardedRef<Chart>,
  ) => {
    const [loading, setLoading] = React.useState(!forPdf ? true : false);

    const options: ApexOptions = {
      chart: {
        type: 'line',
        width: '100%',
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
        animations: {
          enabled: false,
        },
        offsetX: forPdf ? -5 : -10,
      },
      xaxis: {
        type: 'numeric',
        labels: {
          style: {
            fontSize: '8px',
          },
        },
      },
      yaxis: {
        show: true,
        min: yAxis.yMin,
        max: yAxis.yMax,
        tickAmount: yAxis.tickAmount,
        labels: {
          formatter: function (value: number) {
            return value.toFixed(0);
          },
          style: {
            fontSize: '8px',
          },
        },
        axisTicks: {
          show: true,
        },
      },
      grid: {
        show: true,
        yaxis: {
          lines: {
            show: true,
          },
        },
      },
      title: {
        text: !forPdf ? title : '',
        align: 'center',
        margin: 0,
        style: {
          fontSize: '14px',
          fontWeight: 'bold',
          fontFamily: 'Montserrat',
          color: '#0F1A1A',
        },
      },
      subtitle: {
        text: subtitle,
        align: 'center',
        margin: forPdf ? 5 : -10,
        floating: forPdf ? true : false,
        offsetY: forPdf ? 5 : 25,
        style: {
          fontSize: '8px',
          fontFamily: 'Montserrat',
        },
      },
      stroke: {
        width: strokeWidth,
        dashArray: [0],
      },
      legend: {
        show: forPdf ? false : true,
        position: 'top',
        horizontalAlign: 'center',
        fontSize: '9px',
        markers: {
          width: 8,
          height: 8,
        },
        onItemClick: {
          toggleDataSeries: true,
        },
      },
      annotations: {
        xaxis: graphAnnotations,
        yaxis: [
          {
            y: 0,
            borderColor: 'red',
          },
        ],
      },
      markers: {
        size: [0, 0, 2],
        strokeWidth: 0,
        showNullDataPoints: false,
      },
      tooltip: {
        enabled: false,
      },
    };

    useEffect(() => {
      if (!forPdf) {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      }
    }, [data]);

    return (
      <div className={styles.kinematicsGraph_Wrapper}>
        {!loading ? (
          <Chart
            height={forPdf ? 'auto' : '100%'}
            options={options}
            ref={ref}
            series={data}
            type='line'
            width={forPdf ? 250 : '100%'}
          />
        ) : (
          <IonSpinner color='primary' name='bubbles' />
        )}
      </div>
    );
  },
);
